import styled from "styled-components";
import { colors } from "../../helpers/functions";

export const HeaderStyled = styled.div`
    position: fixed;
    width: 100%;
    //height: 45px;
    /*
    background-color: rgba(${colors.blanco_huevo},1);

    -webkit-box-shadow: 1px 2px 14px 0px rgba(0,0,0,0.35);
    -moz-box-shadow: 1px 2px 14px 0px rgba(0,0,0,0.35);
    box-shadow: 1px 2px 14px 0px rgba(0,0,0,0.35);
    */
    z-index: 9999;
    .inner{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 5px;
        .bt_menu{
            background-color: rgba(${colors.naranja_pimiento},1);
            color: rgba(${colors.blanco_huevo},1);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 25px;
            line-height: 25px;
            width: 33px;
            height: 28px;
            cursor: pointer;
            border-radius: 6px;
            &.open{
                background-color: rgba(${colors.blanco_huevo},1);
                color: rgba(${colors.naranja_pimiento},1);
            }
        }
        .box_clover{
            background-color: rgba(${colors.blanco_huevo},1);
            height: 28px;
        }
        .bt_logout{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 28px;
            height: 28px;
            background-color: rgba(${colors.blanco_huevo},1);
            color: rgba(${colors.naranja_pimiento},1);
            font-size: 19px;
            line-height: 19px;
            border-radius: 6px;
        }
    }
`